import axios, { ResponseType } from 'axios';
import { NOTIFICATIONS_URL } from './endpoints';

export type RequestConfig<T = {}> = {
  method?: RequestMethodType;
  baseURL?: string;
  url: string;
  params?: T;
  data?: any;
  pageSize?: number;
  headers?: any;
  responseType?: ResponseType;
  withCredentials?: boolean;
};

export type RequestMethodType = 'GET' | 'POST' | 'PUT' | 'DELETE';

const baseConfig = {
  baseURL: process.env.REACT_APP_API_ROOT,
  withCredentials: true,
};

const getNotifications = async () => {
  const requestConfig: RequestConfig = {
    ...baseConfig,
    url: NOTIFICATIONS_URL,
  };

  const result = await axios.request(requestConfig);

  return result.data.response;
};

const markNotificationAsRead = async (notificationId: string) => {
  const requestConfig: RequestConfig = {
    ...baseConfig,
    url: `${NOTIFICATIONS_URL}/${notificationId}/mark-read`,
    method: 'POST',
  };

  const result = await axios.request(requestConfig);

  return result.data.response;
};

const markAllNotificationAsRead = async () => {
  const requestConfig: RequestConfig = {
    ...baseConfig,
    url: `${NOTIFICATIONS_URL}/mark-read`,
    method: 'POST',
  };

  const result = await axios.request(requestConfig);

  return result.data.response;
};

export default { getNotifications, markNotificationAsRead, markAllNotificationAsRead };
